import script from "./CopyableText.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyableText.vue?vue&type=script&setup=true&lang=js"

import "./CopyableText.vue?vue&type=style&index=0&id=56ec830c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ec830c"]])

export default __exports__